var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/story"
  }, /*#__PURE__*/React.createElement("g", {
    id: "story"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8937 8.60016C24.147 11.8535 24.147 17.1334 20.8937 20.3868C17.6404 23.6401 12.3603 23.6401 9.10699 20.3868C5.85366 17.1334 5.85366 11.8535 9.10699 8.60016C12.3603 5.34682 17.6404 5.34682 20.8937 8.60016Z",
    fill: "#1570EF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M10.0004 27.8535C9.88037 27.8535 9.74704 27.8269 9.62704 27.7868C6.62704 26.5869 4.20036 24.4668 2.5737 21.6668C1.00036 18.9335 0.373701 15.8402 0.787034 12.6935C0.853701 12.1468 1.3737 11.7601 1.90703 11.8268C2.4537 11.8935 2.84035 12.4002 2.77369 12.9468C2.42702 15.6402 2.96039 18.3068 4.30705 20.6535C5.69372 23.0535 7.78702 24.8801 10.3604 25.9068C10.867 26.1201 11.1204 26.6934 10.9204 27.2134C10.7737 27.6134 10.387 27.8535 10.0004 27.8535Z",
    fill: "#1570EF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M6.80046 4.97314C6.50712 4.97314 6.2138 4.83984 6.0138 4.58651C5.66713 4.14651 5.74714 3.51986 6.18714 3.18652C8.7338 1.19986 11.7738 0.146484 15.0005 0.146484C18.1471 0.146484 21.1471 1.15983 23.6671 3.07983C24.1071 3.41317 24.1871 4.03982 23.8538 4.47982C23.5205 4.91982 22.8938 4.99984 22.4538 4.6665C20.2938 3.01317 17.7205 2.14648 15.0005 2.14648C12.2271 2.14648 9.60045 3.05318 7.41378 4.75985C7.22711 4.90651 7.01379 4.97314 6.80046 4.97314Z",
    fill: "#1570EF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M20.0006 27.8528C19.6006 27.8528 19.2273 27.6128 19.0673 27.2261C18.8673 26.7195 19.1073 26.1328 19.6273 25.9195C22.2006 24.8795 24.294 23.0662 25.6806 20.6662C27.0406 18.3195 27.5739 15.6528 27.2139 12.9595C27.1473 12.4128 27.5339 11.9062 28.0806 11.8395C28.6139 11.7728 29.1339 12.1595 29.2006 12.7062C29.6006 15.8395 28.9873 18.9462 27.4139 21.6795C25.8006 24.4795 23.3606 26.5861 20.3606 27.7995C20.2539 27.8261 20.1339 27.8528 20.0006 27.8528Z",
    fill: "#1570EF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskManagement);
export default __webpack_public_path__ + "static/media/riskManagement.aaa4134670e7e13ff866b8c4e75d4af9.svg";
export { ForwardRef as ReactComponent };